import { CASHBACK_ACTION } from '../../constants/actions'

const getCashbackBrands = (page, loading, loadingBrand) => ({
  type: CASHBACK_ACTION.ON_GET_CASHBACK_BRANDS,
  payload: { page, loading, loadingBrand }
})

const getCashbackBrandsBySearch = (
  searchTerm,
  page,
  loading,
  loadingBrand
) => ({
  type: CASHBACK_ACTION.ON_GET_CASHBACK_BRANDS_BY_SEARCH,
  payload: { searchTerm, page, loading, loadingBrand }
})

const getFilterCategories = () => ({
  type: CASHBACK_ACTION.ON_GET_CASHBACK_FILTER_CATEGORIES
})

const getCashbackBrandDetails = (id) => ({
  type: CASHBACK_ACTION.ON_GET_CASHBACK_BRAND_DETAILS,
  payload: { id }
})

const changeCashbackState = (property, value) => ({
  type: CASHBACK_ACTION.CHANGE_STATE,
  payload: {
    property,
    value
  }
})

const changeCashbackInputState = (property, value) => ({
  type: CASHBACK_ACTION.CHANGE_INPUT_STATE,
  payload: {
    property,
    value
  }
})

const resetCashbackState = () => ({
  type: CASHBACK_ACTION.RESET_STATE
})

const selectCategoryForFilter = (field) => {
  return {
    type: CASHBACK_ACTION.ON_SELECT_CATEGORY,
    payload: { field }
  }
}

export {
  getCashbackBrands,
  getCashbackBrandsBySearch,
  changeCashbackInputState,
  getFilterCategories,
  getCashbackBrandDetails,
  changeCashbackState,
  resetCashbackState,
  selectCategoryForFilter
}
